import { ITourComponentProps, TourComponent } from './TourComponent';
import { connect } from 'react-redux';
import { IState } from '../../store';
import { compose, propOr, not } from 'ramda';
import { withEmptyRendering } from '../../utils/hoc';
import { sendUXSEvent } from '../../utils/uxs';

export const handleShow = () => setTimeout(() => sendUXSEvent('novostroiky_3d_desktop'), 3000);

export function mapStateToProps(state: IState): ITourComponentProps {
  const { tourV2 } = state.offerData;

  return {
    tourKey: propOr('', 'tourKey', tourV2),
    onShow: handleShow,
  };
}

export const shouldHideTour = (props: ITourComponentProps) => {
  return not(props.tourKey);
};

export const TourContainer = compose(
  connect<ITourComponentProps>(mapStateToProps),
  withEmptyRendering(shouldHideTour),
)(TourComponent);
